import './checkbox.style.sass';
import template from './checkbox.tpl.pug';

export default {
    selector: 'dbACheckbox',
    template: template(),
    bindings: {
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/checkbox/checkbox.cmpt.js